<template>
  <div>
    <ExcelImport @onDataImported="onDataImported" />
    <PreviewStudents ref="preview-student-dialog" @onSave="onSave" />
  </div>
</template>
<script>
import ExcelImport from '@/modules/excel-import/index.vue'
import PreviewStudents from './PreviewStudents.vue'

export default {
  components: { ExcelImport, PreviewStudents },
  methods: {
    onDataImported(data) {
      this.$refs['preview-student-dialog'].openDialog(data)
    },
    onSave() {
      this.$emit('onSave')
    }
  }
}
</script>
